<template>
  <div class="breadcrumbs">
    <a
      v-for="(item, index) in items"
      :key="index"
      href="#"
      class="breadcrumbs__item"
      @click.prevent="redirectToUrl(item)"
    >{{ item.label }}</a>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  computed: {
    ...mapGetters ({
      items: 'breadcrumb/items',
    }),
  },
  destroyed() {
    this.$store.dispatch('breadcrumb/clear')
  },
  methods: {
    redirectToUrl (item) {
      if (item.url) {
        this.$inertia.visit(item.url)
      }
    },
  },
}
</script>
